import React from 'react';
import { sendAnalyticsEvent } from '@devsbb/analytics-client';

import { CategoryItem } from 'ggApp/types/api/CategoryItem';
import { getCategoryFilterSuffix } from 'ggApp/utils/urlBuilder/getCategoryFilterSuffix';

import { ActiveStore } from 'ggApp/modules/store';
import Item from './Item';
import Wrap from './styles';

type CategoryListProps = {
    categories: CategoryItem[];
    className?: string;
    toggleSubCategories?: () => void;
    closeMenu?: () => void;
    activeCategoryIndex?: number;
    isEUNonBusinessStore: boolean;
    storeActive: ActiveStore;
};

export const CategoryList = ({
    className = '',
    categories = [],
    toggleSubCategories = () => undefined,
    activeCategoryIndex,
    closeMenu = () => undefined,
    isEUNonBusinessStore,
    storeActive,
}: CategoryListProps) => {
    const clickHandler = (event: MouseEvent) => {
        const analyticsValue = (event?.currentTarget as HTMLAnchorElement)?.href;
        sendAnalyticsEvent('Category Clicked', {
            store_id: storeActive.store_id,
            value: analyticsValue,
        });

        if (event?.metaKey || event?.ctrlKey) return;
        closeMenu();
    };

    return (
        <Wrap className={className}>
            {categories.map((category, index) => (
                <Item
                    isActiveCategory={activeCategoryIndex === index}
                    categoryIndex={index}
                    permalink={`${category.permalink}${getCategoryFilterSuffix(
                        category,
                        isEUNonBusinessStore,
                    )}`}
                    key={category.id}
                    onClick={clickHandler}
                    name={category.name}
                    iconPath={category.icon_svg_path}
                    toggleSubCategories={toggleSubCategories}
                    subcategories={category.children}
                />
            ))}
        </Wrap>
    );
};
